// export const calendarsListFromObj = (calendarList) => {
//   let list = [];

//   if (Object.prototype.toString.call(calendarList) === '[object Array]') {
//     //@ts-ignore
//     list = [...calendarList];
//   } else {
//     //@ts-ignore
//     list = [...calendarList.calendarsList];
//   }
//   return list;
// };

export const calendarsListFromObj = (calendarList) => {
  let list: any = [];
  if (calendarList) {
    if (Array.isArray(calendarList)) {
      list = [...calendarList];
    } else if (calendarList.calendarsList) {
      list = [...calendarList.calendarsList];
    }
  }

  return list;
};
